<template>
  <div>
    <Operator
      :disabled="disabled"
      :operators="operators"
      :value.sync="compareType"/>
    <sFormItem
      v-if="$_showParametersWithOperator"
      class="parameters"
      :disabled="disabled"
      prop="parameters"
      :rules="parametersRules">
      <div class="flex">
        <DateMenu
          :change-date="chooseDate"
          clearable
          data-qa="condition-props-date"
          :disabled="disabled"
          :value="parameter.date"/>
        <TimeMenu
          class="ml-2"
          clearable
          data-qa="condition-props-time"
          :disabled="disabled"
          :time.sync="parameter.time"
          @changed="chooseTime"/>
      </div>
    </sFormItem>
  </div>
</template>
<script>
import TimeMenu from 'components/common/inputs/TimeMenu.vue'
import DateMenu from 'components/common/inputs/DateMenu.vue'
import Operator from 'components/automation/conditions/default/operator.vue'
import automations from 'mixins/automations.js'

/**
 * Компонент дат
 */
export default {
  name: 'simpleFieldDate',
  mixins: [ automations ],
  data() {
    const that = this
    return {
      parametersRules: {
        required: true,
        trigger: 'change',
        validator(rule, value, callback) {
          if (!that.parameters?.length) {
            callback(new Error(that.$t('Validate.Required')))
          }
          callback()
        },
      },
    }
  },
  methods: {
    chooseDate(/*value*/) {
    },
    chooseTime(/*value*/) {
    },
  },
  computed: {
    compareType: {
      get() {
        if (!this.value?.compareType) {
          return null
        }
        return this.value.compareType
      },
      set(newValue) {
        const result = this.$_.cloneDeep(this.value)
        result.compareType = newValue
        if (!this.$_showParametersWithOperator) {
          result.parameters = null
        }
        this.$emit('update:value', result)
      }
    },
    parameter: {
      get() {
        if (!this.value?.parameters) {
          return null
        }
        try {
          return JSON.parse(this.value.parameters)[0] || null
        } catch {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: this.$t('Tenders.ErrorConditionParams'),
            showClose: true,
            progress: true,
          })
          return null
        }
      },
      set(newValue) {
        const result = this.$_.cloneDeep(this.value)

        result.parameters = JSON.stringify([newValue])
        this.$emit('update:value', result)
      }
    },
  },
  watch: {
    $_showParametersWithOperator: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue && !newValue) {
          this.parameters = null
        }
      }
    }
  },
  components: {
    TimeMenu,
    Operator,
    DateMenu
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    },
  },
}
</script>
